import { c as _c } from "react/compiler-runtime";
import type { VaultObjectData, VaultValue } from '@onefootprint/core';
import type { DataIdentifier, Entity } from '@onefootprint/request-types/dashboard';
import { Form, Tooltip } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useField from '../../hooks/use-field';
import FieldValue from './components/field-value';
export type FieldProps = {
  di: DataIdentifier;
  entity: Entity;
  renderLabel?: () => React.ReactNode;
  renderValue?: (value: VaultValue | VaultObjectData, isValueDecrypted: boolean) => React.ReactNode;
  monospaced?: boolean;
};
const Field = t0 => {
  const $ = _c(38);
  const {
    di,
    entity,
    renderValue,
    renderLabel,
    monospaced
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "decrypt"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const t2 = useField(entity);
  let customLabel;
  let field;
  let label;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[1] !== di || $[2] !== renderLabel || $[3] !== t || $[4] !== t2) {
    field = t2(di);
    let t8;
    if ($[13] !== renderLabel) {
      t8 = renderLabel ? renderLabel() : undefined;
      $[13] = renderLabel;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    customLabel = t8;
    label = customLabel ?? field.label;
    const ariaLabel = typeof customLabel === "string" ? customLabel : field.label;
    const getTooltipText = () => {
      if (field.isEmpty) {
        return t(_temp, {
          field: field.label
        });
      }
      if (field.isDecrypted) {
        return t(_temp2, {
          field: field.label
        });
      }
      return t(_temp3);
    };
    t7 = "flex justify-between items-center";
    t4 = "flex justify-between items-center w-full";
    t5 = ariaLabel;
    const t9 = !field.showCheckbox;
    let t10;
    if ($[15] !== t9) {
      t10 = cx("block", {
        hidden: t9
      });
      $[15] = t9;
      $[16] = t10;
    } else {
      t10 = $[16];
    }
    t6 = <div className={t10}><Tooltip disabled={field.canDecrypt} content={getTooltipText()}><div className="flex"><Form.Checkbox name="fields" value={di} disabled={field.disabled} label={<div className="text-body-2 text-tertiary">{label}</div>} /></div></Tooltip></div>;
    t3 = cx("flex max-w-[50%]", {
      hidden: field.showCheckbox
    });
    $[1] = di;
    $[2] = renderLabel;
    $[3] = t;
    $[4] = t2;
    $[5] = customLabel;
    $[6] = field;
    $[7] = label;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    customLabel = $[5];
    field = $[6];
    label = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
  }
  let t8;
  if ($[17] !== customLabel || $[18] !== label) {
    t8 = customLabel && React.isValidElement(customLabel) ? customLabel : <div className="text-body-2 text-tertiary">{label}</div>;
    $[17] = customLabel;
    $[18] = label;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t8) {
    t9 = <div className="text-label-2 text-primary">{t8}</div>;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t3 || $[23] !== t9) {
    t10 = <div className={t3}>{t9}</div>;
    $[22] = t3;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== field || $[26] !== monospaced || $[27] !== renderValue) {
    t11 = <div className="flex max-w-[50%]"><FieldValue field={field} renderValue={renderValue} monospaced={monospaced} /></div>;
    $[25] = field;
    $[26] = monospaced;
    $[27] = renderValue;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t10 || $[30] !== t11 || $[31] !== t4 || $[32] !== t5 || $[33] !== t6) {
    t12 = <fieldset className={t4} aria-label={t5}>{t6}{t10}{t11}</fieldset>;
    $[29] = t10;
    $[30] = t11;
    $[31] = t4;
    $[32] = t5;
    $[33] = t6;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== t12 || $[36] !== t7) {
    t13 = <div className={t7}>{t12}</div>;
    $[35] = t12;
    $[36] = t7;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  return t13;
};
export default Field;
function _temp($) {
  return $.fieldEmptyNotAllowed;
}
function _temp2($_0) {
  return $_0.fieldDecryptedNotAllowed;
}
function _temp3($_1) {
  return $_1.notAllowed;
}